import { render, staticRenderFns } from "./TenantAffiliates.vue?vue&type=template&id=febcb78c"
import script from "./TenantAffiliates.vue?vue&type=script&lang=js"
export * from "./TenantAffiliates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports